import { useContext, useEffect } from "react";
import Button, { SIZE, COLOR, STYLE } from "components/Button";
import { setNoOptions, skipRfqData, takeRfqData } from "../../utils";
import { Context } from "pages/Dashboard/Dashboard";

import styles from "./ButtonsGroup.module.scss";
import classNames from "classnames";

const ButtonsGroup = ({
  loading,
  accepted,
  disabled,
  setDisabled,
  setShowModal,
  setErrorModal,
  setErrorMessage,
  setLoading,
  setPercentage,
  setAccepted,
  setAvailableData,
  showDetailedInfo,
  setShowDetailedInfo,
  setEmptyState,
  state,
  byId,
  byOrderIdData,
  setByOrderIdData,
  setShowByOrderId,
  setShowViewRfq
}) => {
  const { rfqData, setRfqData } = useContext(Context);
  const closeTab = () => {
    if (window.opener && window.opener !== window) {
      window.close();
    } else {
      console.warn("This tab cannot be closed programmatically.");
    }
  };
  useEffect(() => {
    if(byId) {
      if(byId.take) {
        let sourceData ={ "source" : byId.source}
        takeRfqData({
          id: byId.id,
          setErrorModal,
          setErrorMessage,
          setAccepted,
          setDisabled,
          rfqData,
          sourceData
        });
      }
    }
  }, [byId])

  return (
    <>
      {!loading &&
        (showDetailedInfo || byOrderIdData?.warning ? (
          <div className={styles.wrapper}>
            <Button
              children="BACK TO NEW RFQ"
              style={STYLE.SECONDARY}
              size={SIZE.LARGE}
              className={styles.button}
              onClick={() => {
                setShowDetailedInfo(false);
                setShowByOrderId(false);
                setShowViewRfq(false);
                setByOrderIdData(null)
              }}
            />
          </div>
        ) : (
          <div className={styles.buttonsGroup}>
            {accepted || (!rfqData.isFirstShown && rfqData.show_no_options_and_bid) ? (
              <>
                <Button
                  children="NO OPTIONS"
                  style={COLOR.NONE}
                  size={SIZE.MIDDLE}
                  className={classNames(styles.button, styles.decline)}
                  disabled={disabled}
                  onClick={async () => {
                    try {
                      await setNoOptions({
                        id: byOrderIdData?.rfq?.id ? byOrderIdData?.rfq?.id: rfqData.id,
                        setErrorModal,
                        setErrorMessage,
                        setLoading,
                        setPercentage,
                        setRfqData,
                        setAccepted,
                        setDisabled,
                        setEmptyState,
                        state,
                      });
                    } finally {
                      closeTab()
                      setShowByOrderId(false);
                      setShowViewRfq(false);
                      setByOrderIdData(null)
                    }
                    setDisabled(true);
                  }}
                />
                <Button
                  children="BID"
                  size={SIZE.MIDDLE}
                  className={styles.button}
                  onClick={() => {
                    setShowModal(true);
                    setAvailableData({
                      id: byOrderIdData?.rfq?.id ? byOrderIdData?.rfq?.id : rfqData.id,
                      email: rfqData.customer?.agentEmail,
                    });
                    setShowByOrderId(false);
                    setShowViewRfq(false);
                    setByOrderIdData(null)
                  }}
                />
              </>
            ) : (
              <>
                <Button
                  children="SKIP RFQ"
                  style={COLOR.NONE}
                  size={SIZE.MIDDLE}
                  className={classNames(styles.button, styles.decline)}
                  onClick={() => {
                    if(byId && byId.id) {
                      skipRfqData({
                        id: rfqData.id,
                        setErrorModal,
                        setErrorMessage,
                        setLoading,
                        setPercentage,
                        setRfqData,
                        setDisabled,
                        setEmptyState,
                        state,
                      });
                      closeTab()
                      
                    } else {
                      skipRfqData({
                        id: byOrderIdData?.rfq?.id ? byOrderIdData?.rfq?.id : rfqData.id,
                        setErrorModal,
                        setErrorMessage,
                        setLoading,
                        setPercentage,
                        setRfqData,
                        setDisabled,
                        setEmptyState,
                        state,
                      });
                      setDisabled(true);
                    }
                    if(byOrderIdData?.rfq) {
                      setShowByOrderId(false);
                      setShowViewRfq(false);
                      setByOrderIdData(null)
                    } 
                  }}
                />
                <Button
                  children="TAKE RFQ"
                  size={SIZE.MIDDLE}
                  className={styles.button}
                  onClick={() => {
                    takeRfqData({
                      id: byOrderIdData?.rfq?.id ? byOrderIdData?.rfq?.id : rfqData.id,
                      setErrorModal,
                      setErrorMessage,
                      setAccepted,
                      setDisabled,
                      rfqData,
                    });
                    setDisabled(true);
                  }}
                />
              </>
            )}
          </div>
        ))}
    </>
  );
};

export default ButtonsGroup;
